<template>
  <div v-if="loaded" class="yxtbiz-ote-quespoint-selector">
    <yxt-select
      v-model="selectedPoints"
      :class="selectClass"
      :disabled="disabled"
      :allow-create="false"
      :multiple="multipleLimit > 1"
      :size="selectSize"
      clearable
      :placeholder="$t('pc_biz_ote_lbl_pleaseselect2')"
      :multiple-limit="multipleLimit"
    >
      <yxt-option
        v-for="item in options"
        :key="item.value"
        :multiple-limit="multipleLimit"
        :label="item.label"
        :value="item.value"
      >
        <yxt-tooltip :content="item.label" open-filter placement="top">
          <span class="d-in-block max-width292 ellipsis">{{ item.label }}</span>
        </yxt-tooltip>
      </yxt-option>
    </yxt-select>
  </div>
</template>

<script>
import { getPointList, getPointListFunc } from '../ques.service';
export default {
  components: {
  },
  data() {
    return {
      loaded: false,
      drawer: false,
      options: [],
      selectedPoints: ''
    };
  },
  props: {
    // 当前选择的考核点集合
    value: {
      type: [Array, String],
      default: () => {
        return this.multipleLimit === 1 ? '' : [];
      }
    },
    // 题库的ID
    libId: {
      type: String,
      default: ''
    },
    // 是否包含编辑功能
    edit: {
      type: Boolean,
      default: false
    },
    // 选择数量
    multipleLimit: {
      type: Number,
      default: 1
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 下拉框样式
    selectClass: {
      type: String,
      default: ''
    },
    // 是否需要更新考核点数据
    needGetPoint: {
      type: Number,
      default: 0
    },
    selectSize: {
      type: String,
      default: 'medium'
    }
  },
  watch: {
    needGetPoint: 'getPoints',
    libId: 'getPoints',
    value: {
      immediate: true,
      handler(val) {
        this.selectedPoints = this.value;
      }
    },
    selectedPoints: {
      handler(val) {
        this.$emit('input', this.selectedPoints);
        this.$emit('change', this.selectedPoints);
      }
    }
  },
  computed: {},
  methods: {
    // 获取目录信息
    getPoints() {
      const api =
        this.$route.meta &&
        this.$route.meta.functionCode === 'ote_ques_lib_mgmt'
          ? getPointListFunc
          : getPointList;
      api(this.libId).then(points => {
        this.options = [];
        points.forEach(point => {
          this.options.push({
            label: point.name,
            value: point.pointId
          });
        });

        // 修改删除考核点 同步页面数据更新
        this.selectedPoints =
          this.selectedPoints &&
          this.selectedPoints.filter(
            id => this.options.findIndex(item => item.value === id) >= 0
          );
        this.$emit('input', this.selectedPoints);
        this.$emit('change', this.selectedPoints);
        this.loaded = true;
      });
    }
  },
  created() {
    this.getPoints();
  }
};
</script>
